var _Circle, _Circle2, _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgAddUser = function SvgAddUser(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 40.03,
    cy: 40,
    r: 37.5,
    stroke: "#4285F4",
    strokeWidth: 5
  })), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, {
    cx: 40.03,
    cy: 30.67,
    r: 9.33,
    fill: "#F7931A"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.45 44a8.04 8.04 0 0 0-7.48 5.1 6.03 6.03 0 0 0 5.61 8.23h13.45v-2.66c0-1.48 1.2-2.67 2.66-2.67h4v-4c0-1.1.68-2.06 1.64-2.46A8.03 8.03 0 0 0 47.6 44H32.45Z",
    clipRule: "evenodd"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#F7931A",
    fillRule: "evenodd",
    d: "M56.03 49.33a1.33 1.33 0 0 0-2.67 0v5.34h-5.33a1.33 1.33 0 1 0 0 2.66h5.33v5.34a1.33 1.33 0 0 0 2.67 0v-5.34h5.33a1.33 1.33 0 1 0 0-2.66h-5.33v-5.34Z",
    clipRule: "evenodd"
  })));
};
export default SvgAddUser;